import React, {useEffect, useState} from 'react'
import {useLocation} from 'react-router'
import Tabs from './Tabs'
import {TabObject} from 'types/tabTypes'

export const RoutingTabs = ({navTabs}: {navTabs: TabObject[]}) => {
  const location = useLocation()
  const [navTabsValue, setNavTabsValue] = useState(location.pathname)

  useEffect(() => {
    const pathName = location.pathname
    const tabValue = navTabs.find(({to}) => to && location.pathname.includes(to))?.value ?? pathName
    setNavTabsValue(tabValue)
  }, [location.pathname, navTabs])

  return <Tabs tabs={navTabs} value={navTabsValue} />
}
